import { DatePicker } from '@material-ui/pickers';
import { getIn } from 'formik';
import React from 'react';
import { Hint } from 'v2/components/Shared/Hint';

import type { FieldProps } from 'formik';

export const DatePickerFormField = ({ field, form, ...props }: FieldProps) => {
  const errorText = getIn(form.errors, field.name);

  const handleChange = (value: any) => {
    form.setFieldValue(field.name, value);
  };

  return (
    <Hint inputName={field.name}>
      <DatePicker
        fullWidth
        format='DD/MM/YYYY'
        helperText={errorText ? errorText : null}
        error={!!errorText}
        {...props}
        {...field}
        onChange={handleChange}
      />
    </Hint>
  );
};
